(function (glob) {
  glob.banner = {
    $header: $('#J_banner'),
    $searchBanner: $('#J_searchBanner'),
    $searchWrapper: $('.search-wrapper'),
    scrollTop: 160,
    init: function () {
      var self = this;
      $(window).on('scroll', function () {
        if ($(window).scrollTop() > self.scrollTop) {
          self.$header.addClass('fixed').append(self.$searchBanner);
          setTimeout(function () {  // 300ms 动画后overflow可见
            if (self.$header.hasClass('fixed')) {
              self.$header.addClass('visible');
            }
          }, 300);
        } else {
          self.$header.removeClass('fixed visible');
          setTimeout(function () {  // 150ms 动画后恢复搜索栏
            if (!self.$header.hasClass('fixed')) {
              self.$searchWrapper.append(self.$searchBanner);
            }
          }, 150);
        }
      })
    }
  }
  glob.banner.init();
}(UC || (UC = {})));